import { useEffect, useState } from "react";
import { dashBoard } from "src/shared/services/servicesv2";
import { DashboardResponse } from "src/shared/types";

const useDashboard = (from?: string, to?: string) => {
  const [data, setData] = useState<DashboardResponse>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dashBoard(from, to)
      .then((res) => setData(res.data))
      .finally(() => setLoading(false));
  }, [from, to]);

  return { data, loading };
};

export default useDashboard;
